<!-- PUBLIC NAV w/ CTA -->
<div class="border-bottom navy-bg public-nav">
	<div class="container">
		<nav
			class="row navbar navbar-static-top mb-0"
			role="navigation">
			<div class="col-lg-5">
				<!-- INFODOCS LOGO -->
				<a href="https://infodocs.co.za/" class="logo-link">
					<img
						title="InfoDocs Logo Colour Transparent"
						src="assets/img/infodocs-logo.png"
						class="logo"
					/>
				</a>
			</div>
			<div class="col-lg-7">
				<!-- CTA -->
				<div class="compliance-form">
					<a routerLink="/account/login" class="btn-navbar btn-login">LOG IN</a>
					<a
						routerLink="/account/register"
						target="_blank"
						class="btn-navbar btn-free-trial mr-0"
						style="width: 23.2%">
						<button>Sign Up</button>
					</a>
				</div>
			</div>
		</nav>
	</div>
</div>
